/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Status_OpenInputs */

const en_reports_status_open = /** @type {(inputs: Reports_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const pt_br2_reports_status_open = /** @type {(inputs: Reports_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Reports_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_status_open = /** @type {((inputs?: Reports_Status_OpenInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Status_OpenInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_status_open(inputs)
	return pt_br2_reports_status_open(inputs)
});